import { useTranslation } from "next-i18next";

import getDeliveryMethods from "../../data/getDeliveryMethods";
import type { TStaticInitialOrderData, TStaticOrderData } from "../../types";
import getParcelWeights from "../../data/getParcelWeights";

const useStaticData = (staticOrderData?: TStaticInitialOrderData): TStaticOrderData => {
  const { t } = useTranslation();

  if (!staticOrderData) {
    return {
      countriesFrom: [],
      deliveryMethods: [],
      parcelWeights: [],
      paymentMethods: [],
      affiliateData: null,
      isScrollToReceiverInfo: null,
    };
  }

  const { countriesFrom, paymentMethods, affiliateData, isScrollToReceiverInfo } = staticOrderData;
  const deliveryMethods = getDeliveryMethods(t);
  const parcelWeights = getParcelWeights(t);
  const staticData = {
    countriesFrom,
    deliveryMethods,
    parcelWeights,
    paymentMethods,
    affiliateData,
    isScrollToReceiverInfo,
  };
  return staticData;
};
export default useStaticData;
